export enum UserSource {
	TABU = 1,
	RDC = 2,
	EJARI = 3,
	TAQYIMEE = 4,
	DUBAI_BROKER = 5,
	TRAKHEESI = 6,
	SIMSARI = 7,
	SSO = 8,
}
